<div>
    <button mat-button (click)="testbool = !testbool; ">Click me!</button> <br>
    <a [routerLink]="['inventory']">Inventory</a> <br>
    <a [routerLink]="['inventory', 'a']">Inventory A</a> <br>
    <a [routerLink]="['inventory', 'b']">Inventory B</a> <br>
    <a [routerLink]="['jobs']">Jobs</a> <br>
    <router-outlet *ngIf="testbool"></router-outlet>
</div>